import { DataHandler } from '../utils/DataHandler';

import type { EditorialContent } from '@shared-types/editorial.types';
import type { StateCreator } from '@shared-types/zustand.types';
import { Warn } from '@utilities/logging';

export type EditorialSlice = {
  editorialInfo: EditorialContent[];
  isLoadingEditorials: boolean;
  loadEditorialInfo: (playersId: string[]) => Promise<void>;
};

export const editorialSlice: StateCreator<EditorialSlice> = (set) => ({
  editorialInfo: [] as EditorialContent[],
  isLoadingEditorials: true,
  loadEditorialInfo: async (playerIds) => {
    if (!playerIds?.length) return;

    set({ isLoadingEditorials: true }, false, 'loadEditorialInfo');

    try {
      const apiInstance = DataHandler.getInstance();
      const data = await apiInstance.loadEditorialInfo(playerIds.slice(0, 30));
      set({ editorialInfo: data, isLoadingEditorials: false }, false, 'loadEditorialInfo');
    } catch (error) {
      Warn('Failed to load editorial info', error);
      set({ isLoadingEditorials: false }, false, 'loadEditorialInfo');
    }
  },
});
